import Swal from "sweetalert2";
import { sesionExpired } from "../../constants/auth/sesionExpired";
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference";
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

              /**
   * Error handle
   * Funcion que genera administra errores al hacer solicitudes al servidor
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - 
   */

const errorHandler = (dispatch, error, defaultMessage, history) => {
  
    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();
  
    if (error.response) {
      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history); 
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: defaultMessage || 'Error al procesar la solicitud.',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
        });
      }
    } else {
      actionErrorConnection(error, defaultMessage || 'Error de conexión.');
    }
  };
  
  export default errorHandler;
